import React from 'react';
import { Spinner } from 'react-bootstrap';
import { Card } from '~/components/Card';
import { ServicesContext } from '~/services';

export function ProfileSettings() {
    const services = React.useContext(ServicesContext);
    const printingEnabled = services.user.patientPrintingEnabled();
    const user = services.user.get();
    const [loading, setLoading] = React.useState(false);

    async function togglePatientPrinting() {
        setLoading(true);
        const updatedRoles = [...user.global_roles];
        if (!printingEnabled) {
            updatedRoles.push('ROLE_PATIENT_PRINTING');
        } else {
            updatedRoles.splice(updatedRoles.indexOf('ROLE_PATIENT_PRINTING'), 1);
        }
        await services.user.update(
            {
                global_roles: updatedRoles,
            },
            { handledErrors: true }
        );
        setLoading(false);
    }

    return (
        <Card
            className="mt-3"
            title={
                <div className="row mb-0">
                    <div className="col-8 align-self-center">General Settings</div>
                </div>
            }
        >
            <div className="row align-items-center">
                <div className="col-3 text-end">
                    <div>Patient Printing</div>
                </div>
                <div className="col-3">
                    {printingEnabled ? 'On' : 'Off'}
                    <i
                        className="fa-regular fa-question-circle ms-2"
                        title="Allows you to create printable PDF summaries of patient gaps and health history."
                    >
                        <span className="sr-only">
                            Allows you to create printable PDF summaries of patient gaps and health
                            history.
                        </span>
                    </i>
                </div>
                <div className="col-6 text-end text-nowrap">
                    <button
                        className={`btn ${printingEnabled ? 'btn-secondary' : 'btn-primary'}`}
                        type="button"
                        onClick={togglePatientPrinting}
                        disabled={loading}
                    >
                        {loading && (
                            <Spinner
                                animation="border"
                                className="me-1"
                                role="status"
                                size="sm"
                                variant="light"
                            />
                        )}
                        {printingEnabled ? 'Disable' : 'Enable'}
                    </button>
                </div>
            </div>
        </Card>
    );
}
